import api from './api';

class ResourceAllocationService {
  // Get all resource allocations with pagination and filtering
  static async getResourceAllocations(params = {}) {
    try {
      console.log('[ResourceAllocationService] Fetching resource allocations with params:', params);
      const response = await api.get('/resource-allocation', { params });
      console.log('[ResourceAllocationService] Fetch successful:', response.data);
      return response.data;
    } catch (error) {
      console.error('[ResourceAllocationService] Error fetching resource allocations:', error.message, error.response?.data);
      throw this.handleError(error);
    }
  }

  // Get resource allocation by ID
  static async getResourceAllocation(id) {
    try {
      console.log('[ResourceAllocationService] Fetching resource allocation with ID:', id);
      const response = await api.get(`/resource-allocation/${id}`);
      console.log('[ResourceAllocationService] Fetch by ID successful:', response.data);
      return response.data;
    } catch (error) {
      console.error('[ResourceAllocationService] Error fetching resource allocation:', error.message, error.response?.data);
      throw this.handleError(error);
    }
  }

  // Create new resource allocation
  static async createResourceAllocation(allocationData) {
    try {
      console.log('[ResourceAllocationService] Creating resource allocation with data:', allocationData);
      const response = await api.post('/resource-allocation', allocationData);
      console.log('[ResourceAllocationService] Create successful:', response.data);
      return response.data;
    } catch (error) {
      console.error('[ResourceAllocationService] Error creating resource allocation:', error.message, error.response?.data);
      throw this.handleError(error);
    }
  }

  // Update resource allocation
  static async updateResourceAllocation(id, allocationData) {
    try {
      console.log('[ResourceAllocationService] Updating resource allocation ID:', id);
      console.log('[ResourceAllocationService] Update data:', allocationData);
      const response = await api.put(`/resource-allocation/${id}`, allocationData);
      console.log('[ResourceAllocationService] Update successful. Response:', response.data);
      return response.data;
    } catch (error) {
      console.error('[ResourceAllocationService] Error updating resource allocation:');
      console.error('  - Message:', error.message);
      console.error('  - Status:', error.response?.status);
      console.error('  - Response Data:', error.response?.data);
      console.error('  - Full Error:', error);
      throw this.handleError(error);
    }
  }

  // Delete resource allocation
  static async deleteResourceAllocation(id) {
    try {
      console.log('[ResourceAllocationService] Deleting resource allocation ID:', id);
      const response = await api.delete(`/resource-allocation/${id}`);
      console.log('[ResourceAllocationService] Delete successful:', response.data);
      return response.data;
    } catch (error) {
      console.error('[ResourceAllocationService] Error deleting resource allocation:', error.message, error.response?.data);
      throw this.handleError(error);
    }
  }

  // Handle API errors
  static handleError(error) {
    console.log('[ResourceAllocationService] handleError called with error:', error);
    if (error.response) {
      // Server responded with error status
      const errorData = error.response.data;
      const errorMessage = errorData?.message || 
                          errorData?.error || 
                          (errorData?.errors && errorData.errors.length > 0 
                            ? errorData.errors.map(e => e.msg || e.message).join(', ') 
                            : 'An error occurred');
      
      console.error('[ResourceAllocationService] Server error - Status:', error.response.status, 'Message:', errorMessage);
      
      return {
        message: errorMessage,
        status: error.response.status,
        data: errorData
      };
    } else if (error.request) {
      // Request was made but no response received
      console.error('[ResourceAllocationService] Network error - no response received');
      return {
        message: 'Network error - please check your connection',
        status: 0
      };
    } else {
      // Something else happened
      console.error('[ResourceAllocationService] Unexpected error:', error.message);
      return {
        message: error.message || 'An unexpected error occurred',
        status: 0
      };
    }
  }
}

export default ResourceAllocationService;